<script setup lang="ts">
import type { PartsTreeNode } from "@/types/field-observations.types";

defineProps<{
  nodes: PartsTreeNode[];
  level?: number;
  parentPath?: string;
}>();
</script>

<template>
  <ul class="tree-preview" :class="{ 'tree-preview--root': !level }">
    <li v-for="(node, index) in nodes" :key="index" class="tree-preview__item">
      <div class="tree-preview__node">
        <span class="tree-preview__path">{{
          parentPath ? `${parentPath}.${index + 1}` : `${index + 1}`
        }}</span>
        <span>{{ node.name }}</span>
      </div>
      <FieldPartTemplateTreePreview
        v-if="node.children?.length"
        :nodes="node.children"
        :level="(level || 0) + 1"
        :parent-path="
          parentPath ? `${parentPath}.${index + 1}` : `${index + 1}`
        "
      />
    </li>
  </ul>
</template>

<style lang="scss" scoped>
.tree-preview {
  list-style: none;
  padding-left: 1.25rem;
  margin: 0;

  &--root {
    padding-left: 0;
  }

  &__item {
    position: relative;
  }

  &__node {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.25rem 0;
    font-size: 0.875rem;
    color: var(--bs-body-color);
  }

  &__path {
    font-size: 0.75rem;
    font-weight: 600;
    color: var(--bs-secondary-color);
    font-variant-numeric: tabular-nums;
    min-width: 1.5rem;
  }
}
</style>
